import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  static properties = {
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.submitButton = this.querySelector('[type="submit"]')

    this.bundleQuantityDecrement = this.querySelector('.js-quantity-decrement')
    this.bundleQuantityIncrement = this.querySelector('.js-quantity-increment')
    this.bundleInput = this.querySelector('.js-quantity-selector__field')
    this.initial = 1
    this.max = 99

    this.bundleQuantityDecrement?.addEventListener(
      'click',
      this.decrement.bind(this)
    )
    this.bundleQuantityIncrement?.addEventListener(
      'click',
      this.increment.bind(this)
    )

    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this))

  
    this.form?.addEventListener('click', (e) => {
      const btn = e.target.closest && e.target.closest('button, input[type="submit"]')
      if (btn) this._lastSubmitButton = btn
    })

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })

    this._value = this.initial
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver?.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault()

  
  const submitter = event.submitter || this._lastSubmitButton || document.activeElement
  const isCheckoutBtn = submitter?.classList?.contains?.('btn-checkout')

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')
    
    const formPayload = JSON.parse(serializeForm(this.form))

    // FRX-43440: Remove accelerated checkout-only fields
    // from normal Add to Bag AJAX request
    if (this.form.querySelector('[data-frx-wallet]')) {
      this.form
        .querySelectorAll('[data-frx-43440-wallet-item]')
        .forEach((input) => {
          delete formPayload[input.name]
        })
    }

    const response = await addToCart(formPayload)
    reRenderShopifySections(response)
    
    this.dispatchEvent(
      new CustomEvent('productForm:afterAdd', {
        bubbles: true,
        composed: true,
        detail: {
          response,
          formPayload
        }
      })
    )
    
    if(isCheckoutBtn){
      window.location.href = '/checkout'
    }else {

      if (this.showMiniCartAfterSubmission) {
      utils.toggle(document.body, ['mini-cart-is-active'])
      }

    this.dispatchEvent(
      new CustomEvent('productAdded', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'cart-notification',
        },
      })
    )
    }
    

    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')

    this.recipientFormToggle = this.querySelector('.js-recipient-form-toggle')
    if (this.recipientFormToggle && this.recipientFormToggle.checked) {
      this.recipientFormToggle.checked = false
      this.recipientFormToggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  increment() {
    if (this._value == this.max) {
      return
    }
    this._value += 1
    this.bundleInput.value = this._value
  }

  decrement() {
    if (!this._value || this._value == 1) {
      return
    }

    this._value -= 1
    this.bundleInput.value = this._value
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
